import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import "./homeCta.css";

export default function HomeCta() {
  return (
    <section className="home-cta">
      <div className="home-cta__inner">
        <div className="home-cta__left">
          <div className="home-cta__eyebrow">
            <span className="home-cta__dot" />
            <span>LET'S GET STARTED</span>
          </div>

          <h2 className="home-cta__title">
            <span>Data, Collected &amp;</span>
            <span className="home-cta__title-accent">Annotated.</span>
            <span>Teams, Deployed.</span>
            <span>Ready When You Are.</span>
          </h2>
        </div>

        <div className="home-cta__right">
          <p className="home-cta__description">
            Whether you need precisely annotated training data,
            real-world data collection, a dedicated in-house team,
            or other staffing solutions, Qualitas Global delivers
            all three under one roof. Backed by over a decade of
            experience, we back every engagement with a risk-free
            2-day pilot before you commit.
          </p>

          <div className="home-cta__actions">
            <Link to="/contact-us" className="home-cta__button">
              <span>Get Your Data Annotated. Get Your Model Ready</span>
              <ArrowUpRight
                className="home-cta__arrow"
                size={19}
                strokeWidth={1.8}
                aria-hidden="true"
              />
            </Link>

            <Link
              to="/contact-us"
              className="home-cta__button home-cta__button--secondary"
            >
              <span>Request Free Annotation Demo</span>
              <ArrowUpRight
                className="home-cta__arrow"
                size={19}
                strokeWidth={1.8}
                aria-hidden="true"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
